export default __webpack_public_path__ + "static/parc-jean-drapeau-6ae419d0a09966d0c1aa962e3619db6c.png";